import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { PersistGate } from 'redux-persist/integration/react'

import AppProvider from 'providers/AppProvider'
import MdxProvider from 'providers/MdxProvider'
import CookieYes from 'components/ui/CookieYes'
import ScrollToTop from 'components/ui/ScrollToTop/ScrollToTop'
import { AppApiProvider, AuthProvider } from 'api'
import { i18nInitialize } from 'contexts/I18nContext'
import { WithChild } from 'utils'
import FontsCss from 'styles/FontsCss'
import App from 'containers/App'
import { store, persistor } from 'redux/store'
import { appConfig } from 'config/app'
import { authRoutes } from 'routes'

i18nInitialize('main').then()

const AppAuthProvider = ({ children }: WithChild) => {
  const history = useHistory()

  const onLogout = useCallback(() => {
    persistor.purge().then(() => {
      history.push(authRoutes.views.login.path)
    })
  }, [history])

  return (
    <AuthProvider store={store} onLogout={onLogout}>
      {children}
    </AuthProvider>
  )
}

const tagManagerArgs = {
  gtmId: 'G-W79KNHY460',
}

if (appConfig.appEnv === 'production') {
  TagManager.initialize(tagManagerArgs)
}

export default function Root({ helmetContext }: any) {
  return (
    <HelmetProvider context={helmetContext}>
      <AppProvider>
        <MdxProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AppApiProvider
                platform={'app'}
                brand={appConfig.brand}
                baseURL={appConfig.apiBaseUrl}
              >
                <AppAuthProvider>
                  <FontsCss />
                  <Helmet>
                    <title>GameSkinX - Premium CS 2 Skins for Ultimate Gaming Experience</title>
                    <meta
                      name='description'
                      content='Discover GameSkinX, your trusted store for CS 2 skins. Safe, manual delivery, competitive prices, and fast service for all gamers.'
                    />
                  </Helmet>
                  <ScrollToTop />
                  <App />
                  <CookieYes cbid='30aa39c33cb5e1d7968a1369' />
                </AppAuthProvider>
              </AppApiProvider>
            </PersistGate>
          </Provider>
        </MdxProvider>
      </AppProvider>
    </HelmetProvider>
  )
}
